import {
    getPagesElements,
    scrollElementIntoView,
    setPagesEventListeners,
} from "../../../../../magnolia-component-library/assets/js/utils/overview";
import { getQueryParams } from "../../../../../magnolia-component-library/assets/js/utils/queryParams";

export default function(el) {
    const pagesEls = getPagesElements(el);
    const queryParams = getQueryParams();

    setPagesEventListeners(pagesEls, queryParams);

    scrollElementIntoView(queryParams);
}
